import React from "react";
import { useI18n } from "../i18n";
import { ArrowUpRight, Newspaper } from "lucide-react";

const MENTIONS = [
  {
    outlet: "Brazilian Times",
    title_en: "How Movix is winning Boston's Brazilian community over",
    title_pt: "Como a Movix conquistou a comunidade brasileira de Boston",
    quote_en: "Movix doesn't ask for an International Driving Permit, accepts the Brazilian license and answers in WhatsApp in minutes — a rarity in Boston.",
    quote_pt: "A Movix não pede IDP, aceita CNH brasileira e responde no WhatsApp em minutos — uma raridade em Boston.",
    year: "2025",
    url: "#",
  },
  {
    outlet: "Boston Globe Brazilian",
    title_en: "The Everett rental that thinks like a hotel concierge",
    title_pt: "A locadora de Everett que pensa como concierge de hotel",
    quote_en: "Walk-in, Portuguese-speaking team, prices half the airport counters and unlimited miles on every car.",
    quote_pt: "Atendimento walk-in em português, preço pela metade dos balcões do aeroporto e milhas livres em todo carro.",
    year: "2025",
    url: "#",
  },
  {
    outlet: "Eater Boston",
    title_en: "10 best independent businesses in Greater Boston",
    title_pt: "10 melhores negócios independentes da Grande Boston",
    quote_en: "Movix made our list for service that feels personal — your name on the keychain, your music ready in the car.",
    quote_pt: "A Movix entrou na nossa lista pelo serviço pessoal — seu nome no chaveiro, sua playlist pronta no carro.",
    year: "2025",
    url: "#",
  },
  {
    outlet: "Visit Massachusetts",
    title_en: "Renting a car for Cape Cod: where locals actually go",
    title_pt: "Aluguel para Cape Cod: onde os locais realmente vão",
    quote_en: "Featured partner for affordable rentals to Cape Cod, with insurance and unlimited miles included.",
    quote_pt: "Parceiro recomendado para aluguel acessível com destino a Cape Cod, com seguro e milhas livres inclusos.",
    year: "2026",
    url: "#",
  },
];

const Press = () => {
  const { lang } = useI18n();
  const isPt = lang === "pt";
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20" data-testid="press-page">
      <p className="text-label text-[#FFB400]">
        <span className="line-accent" />
        {isPt ? "Imprensa & mídia" : "Press & Media"}
      </p>
      <h1 className="mt-4 font-heading text-5xl sm:text-6xl font-bold tracking-tighter text-white max-w-3xl">
        {isPt
          ? "Eles já contaram a história da Movix."
          : "They've already told the Movix story."}
      </h1>
      <p className="mt-6 max-w-2xl text-zinc-300 text-lg leading-relaxed">
        {isPt
          ? "Selecionamos as menções na mídia e os artigos que ajudaram a comunidade a conhecer a gente. Quer uma entrevista, ficha técnica ou imagens de imprensa? Fale com a gente."
          : "Selected media mentions and articles that introduced Movix to the community. Need an interview, fact sheet or press photos? Just ask."}
      </p>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
        {MENTIONS.map((m, i) => (
          <a
            key={i}
            href={m.url}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-[#0d0d0d] border border-white/10 p-8 lift block"
            data-testid={`press-card-${i}`}
          >
            <div className="flex items-center justify-between">
              <p className="text-label text-[#FFB400]">{m.outlet}</p>
              <ArrowUpRight
                size={20}
                className="text-zinc-500 group-hover:text-[#FFB400] transition-colors"
              />
            </div>
            <h3 className="mt-4 font-heading text-2xl text-white tracking-tight">
              {isPt ? m.title_pt : m.title_en}
            </h3>
            <p className="mt-4 text-zinc-300 leading-relaxed">
              “{isPt ? m.quote_pt : m.quote_en}”
            </p>
            <p className="mt-6 text-xs text-zinc-500 font-mono-ui uppercase tracking-widest">
              {m.year}
            </p>
          </a>
        ))}
      </div>

      <section
        className="mt-24 border-t border-white/10 pt-12 grid grid-cols-1 md:grid-cols-2 gap-12"
        data-testid="press-contact"
      >
        <div>
          <p className="text-label text-[#FFB400]">
            <span className="line-accent" />
            {isPt ? "Imprensa" : "Press"}
          </p>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-white">
            {isPt ? "Mídia kit & contato" : "Media kit & contact"}
          </h2>
          <p className="mt-4 text-zinc-400 leading-relaxed">
            {isPt
              ? "Materiais com logos em PNG/SVG, fotos da frota em alta resolução, biografias da equipe e ficha técnica disponíveis sob demanda."
              : "Logo files (PNG/SVG), high-res fleet photos, team bios and a 1-pager fact sheet available on request."}
          </p>
        </div>
        <div className="bg-[#0d0d0d] border border-white/10 p-8">
          <Newspaper size={28} className="text-[#FFB400]" />
          <p className="mt-4 text-white font-medium">movixcarrental@gmail.com</p>
          <p className="text-zinc-500 text-sm">(561) 455-6277</p>
          <p className="mt-4 text-xs text-zinc-600 font-mono-ui uppercase tracking-widest">
            Mon–Fri · 9:00 — 18:00
          </p>
        </div>
      </section>
    </div>
  );
};

export default Press;
